import * as React from "react";
import { Segment, Grid, Header, Button, List, GridRow, GridColumn, ListItem, ListHeader } from "@/components/bp/bp-ui";
import { TranslationContext } from "../Contexts/TranslationContext";
import { ClientResources, DnaMatchCaseRunCreateModel, QueriesClient, RunParameterModel } from "@app/api2/api";
import { IParameterRenderer } from "./ParameterRendererAbstracts";
import { ParametersView } from "./ParametersView";
import { BPButton } from "@/components/bp/bpbutton";

interface IReviewDnaMatchProps {
    model: DnaMatchCaseRunCreateModel;
    onComplete: (values: any) => void;
    router: any;
    parameterRenderer: IParameterRenderer;
}

class ReviewDnaMatchState {
    secondaryParametersCollapsed: boolean = true;
}

export class ReviewDnaMatch extends React.Component<IReviewDnaMatchProps, ReviewDnaMatchState> {
    
    private queries = new QueriesClient();
    constructor(props, context) {
        super(props, context);

        this.state = new ReviewDnaMatchState();

    }

    async componentDidMount() {
        var settings = await this.queries.getSettings();
        this.setState({ secondaryParametersCollapsed: settings.secondaryParametersCollapsed })
    }



    render() {
        const population = this.props.model.populations.find((p) => (p.id === this.props.model.populationId));
        return (<TranslationContext.Consumer>{t =>
            <div>
                {!this.state.secondaryParametersCollapsed && <Grid columns={4}>
                    <GridRow>
                        <GridColumn>
                            <Header attached="top">{t.caseRun.general}</Header>
                            <Segment attached>
                                <List>
                                    <ListItem>
                                        <ListHeader>{t.common.population}</ListHeader>
                                        {population != null ? population.name : ""}
                                    </ListItem>
                                </List>
                            </Segment>
                        </GridColumn>
                        <GridColumn>
                            <Header attached="top">{t.common.evidence}</Header>
                            <Segment attached>
                                <List>
                                    {this.props.model.evidence.filter((p) => (p.selected)).map((p) => (
                                        <ListItem key={p.id}>{p.name}</ListItem>
                                    ))}
                                </List>
                            </Segment>
                        </GridColumn>
                        <GridColumn>
                            <Header attached="top">{t.common.reference}</Header>
                            <Segment attached>
                                <List>
                                    {this.props.model.references.filter((p) => (p.selected)).map((p) => (
                                        <ListItem key={p.id}>{p.name}</ListItem>
                                    ))}
                                </List>
                            </Segment>
                        </GridColumn>
                        <GridColumn>
                            <Header attached="top">{t.common.qualityControlCases}</Header>
                            <Segment attached>
                                <List>
                                    {this.props.model.qualityCheckCases.filter((p) => (p.selected)).map((p) => (
                                        <ListItem key={p.caseId}>{p.name}</ListItem>
                                    ))}
                                </List>
                            </Segment>
                        </GridColumn>

                    </GridRow>
                </Grid>}
                {/* <Header attached="top">{t.common.parameters}</Header> */}
                {/* <Segment attached> */}
                <ParametersView secondaryParametersCollapsed={this.state.secondaryParametersCollapsed} parameters={this.props.model.parameters} parameterRenderer={this.props.parameterRenderer} model={{ ...this.props.model, efmCaseId: this.props.model.efmCaseId, hp: this.props.model.references }} />
                {/* </Segment> */}
                <Segment basic clearing>
                    <BPButton floated="right" type="submit" onClick={this.props.onComplete} positive primary>{t.caseRun.queueRun}</BPButton>
                </Segment>
            </div>}</TranslationContext.Consumer>);
    }
}



